export const MARIE_PAGES = [
  {
    type: "cover",
    title: "Carnet de Marie",
    color: "bg-amber-200",
  },
  {
    type: "text",
    title: "",
    body: [
      "• Call client Origami – mardi 15h",
      "• Préparer slides pour démo interne",
      "• Vérifier que les logs incidents sont bien activés avant la conf",
      "",
      "• Perso : rendez-vous véto pour Nala jeudi 10h",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "• Liste idées à ne pas oublier :",
      "  - demander à Samir un point rapide sur la sécu",
      "  - booker la salle pour la conf de presse",
      "  - refaire la checklist pré-démo",
      "",
      "• Nala :",
      "  - penser à racheter des croquettes (poulet, pas saumon)",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "Notes perso:",
      "  - éviter d'utiliser des dates comme mots de passe",
      "  - trouver quelque chose de simple à retenir,",
      "    mais que moi seule associerais à ce poste",
      "",
      "Rappel pour moi-même :",
      "  \"Nala\" est déjà utilisée comme mot de passe pour trop de choses.",
      "  Arrêter d'en parler devant tout le monde aussi...",
    ].join("\n"),
  },
];

export const ALEX_PAGES = [
  {
    type: "cover",
    title: "Carnet d'Alex",
    color: "bg-amber-200",
  },
  {
    type: "text",
    title: "",
    body: [
      "To-do boulot :",
      "  - mettre à jour le planning support",
      "  - rappeler Zoé pour le bug paiement",
      "",
      "Post-it mental :",
      "  - ne plus dire \"ça marche en local\" en réunion",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "Mémos perso :",
      "  - Anniv Zoé : 12/03",
      "  - Code portail parking (à changer) : 1203",
      "  - Ancien mot de passe Slack : ZOE1203  (à virer partout)",
      "",
      "Idées mots de passe (à NE PAS utiliser) :",
      "  - Zoe_1203",
      "  - Spring2024!",
      "  - Coffee4ever",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "  - Le match de Nadal hier incroyable → penser à reprendre le tennis",
      "  - vérifier si \"Rafa2019\" n'est pas utilisé quelque part",
      "",
      "Conclusion :",
      "  il faut que je me fasse un gestionnaire de mots de passe. Vraiment.",
    ].join("\n"),
  },
];

export const SAMIR_PAGES = [
  {
    type: "cover",
    title: "Carnet de Samir",
    color: "bg-amber-200",
  },
  {
    type: "text",
    title: "",
    body: [
      "Réunion sécu :",
      "  - refaire la check-list mots de passe",
      "  - expliquer POURQUOI \"admin/admin\" est un crime",
      "  - montrer exemples d'attaques basées sur les habitudes",
      "",
      "Idée slide :",
      "  \"Si votre mot de passe est le nom de votre animal + 123,",
      "   vous n'avez pas de mot de passe.\"",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "Notes perso :",
      "  - Chien chez mes parents : Balthazar",
      "  - Balthazar → EXEMPLE DE MAUVAIS MOT DE PASSE",
      "  (penser à changer le code de ma boite en verre du coup !)",
      "",
      "Rappeler en démo :",
      "  \"Si vous pouvez le deviner, les attaquants aussi.\"",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "Brainstorm sécu (brouillon) :",
      "  - générer des mots de passe aléatoires",
      "  - utiliser une phrase + variations",
      "  - gestionnaire de mots de passe obligatoire",
      "",
      "Exemples à ne PAS garder :",
      "  - Rock4ever!",
      "  - 0rigami2024",
    ].join("\n"),
  },
];

export const NOTEBOOK_PAGES = [
  {
    type: "cover",
    title: "Notes Techniques — Origami",
  },
  {
    type: "text",
    title: "",
    body: [
      "Brainstorm — choses à vérifier sur Origami v1.9 :",
      "",
      "• Module 'prévision de réponses' encore trop lent",
      "• Confusion entre 'tâches urgentes' et 'tâches ignorables'",
      "   → résultat : Origami ferme les tickets importants, génial.",
      "",
      "• Bug récurrent :",
      "   Message système → “Origami ne coopère pas”",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "  (problème de droits ? surcharge ? dépression de l’IA ?)",
      "",
      "• Tester l’intégration des journaux incidents",
      "   (penser à demander un accès étendu… si possible un jour)",
      "",
      "Idées notées en speed (ne pas juger) :",
      "",
      "• Ajouter un mode 'super motivé' où Origami félicite tout ce qu’on fait",
      "   → risque de réduire la productivité à 0, mais ambiance sympa.",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "• Propositions extravagantes :",
      "   - détecteur de sarcasme (bonne chance)",
      "   - paramètre 'niveau de patience utilisateur'",
      "",
      "",
      "• TODO:",
      "   - retrouver QUI a laissé un post-it “ça marche chez moi” sur le serveur",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "Notes sans ordre (à classer un jour) :",
      "",
      "• Analyse des logs : toujours trop de warnings ignorés",
      "• Mettre à jour la doc interne (haha.)",
      "",
      "• Penser à refaire le schéma réseau VRAIMENT propre",
      "   — celui au tableau est « abstrait » (pour rester poli)",
      "   En plus il sert à rien et n'est pas à jour",
      "",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "• Journal personnel :",
      "   On devrait arrêter de laisser traîner des puzzles en bois au bureau.",
      "   J’ai passé 20 minutes dessus ce matin pour rien.",
      "",
      "• Rappel :",
      "   Ce carnet n'est PAS pour les mots de passe.",
      "   (Ne surtout pas refaire l'erreur du \"post-it sur l'écran\".)",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "• Note pour plus tard :",
      "   Arrêter aussi les déploiements et les \"petites modifs\" après 22h.",
      "   Personne n'est vraiment lucide à cette heure-là, et ça finit en incident.",
      "   (Et en nuits blanches pour tout le monde.)",
    ].join("\n"),
  },
];